import type { FC } from "react";
import ResourceFileStyle from "../../styles/ResourceFileItem.module.css";

type FileItemProps = {
  fileType?: string;
  resourceName?: string;
  status?: string;
  fileName?: string;
  fileUrl?: string;
  id?: string;
  onCopy?: (fileUrl: string) => void;
  onDownload?: (fileUrl: string, fileName: string) => void;
  onDelete?: (key: string) => void;
};

const ResourceFileItem: FC<FileItemProps> = ({
  resourceName,
  status,
  fileType,
  fileName,
  fileUrl,
  onCopy,
  onDownload,
  onDelete,
  id,
}) => {
  return (
    <div
      className={
        status === "active"
          ? ResourceFileStyle.fileCard
          : ResourceFileStyle.deletedResource
      }
      key={id}
    >
      <div className={ResourceFileStyle.fileIcon}>
        <svg
          className={
            fileType === "pdf"
              ? ResourceFileStyle.pdfIcon
              : ResourceFileStyle.imageIcon
          }
        >
          <use xlinkHref={`/assets/sprite.svg#icon-zip`} />
        </svg>
      </div>
      <p className={ResourceFileStyle.fileName}>{resourceName}</p>
      <div className={ResourceFileStyle.fileActions}>
        <button
          className={ResourceFileStyle.actionButton}
          onClick={() => fileUrl && onCopy?.(fileUrl)}
        >
          <svg className={ResourceFileStyle.actionIcon}>
            <use xlinkHref="/assets/sprite.svg#icon-file_copy" />
          </svg>
        </button>

        <button
          className={ResourceFileStyle.actionButton}
          onClick={() => fileUrl && onDownload?.(fileUrl, fileName || "file")}
        >
          <svg className={ResourceFileStyle.actionIcon}>
            <use xlinkHref="/assets/sprite.svg#icon-file_download" />
          </svg>
        </button>

        <button
          className={ResourceFileStyle.actionButton}
          onClick={() => id && onDelete?.(id)}
        >
          <svg className={ResourceFileStyle.actionIcon}>
            <use xlinkHref="/assets/sprite.svg#icon-trash" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ResourceFileItem;
